interface NaviBannerProps {
  is_url: string;
  web_url: string;
  mobile_url: string;
  altText?: string;
}

export function NaviBannerCarousel(props: NaviBannerProps) {
  const altText = props.altText ?? "TTEC Intranet - Navi";
  return (
    <div className="card border-0 mb-0 pb-0">
      {props.is_url ? (
        <a href={props.is_url} target="_blank" rel="noopener noreferrer">
          <img src={props.web_url} className="w-100 img-fluid desktopImage" alt={altText} />
          <img src={props.mobile_url} className="w-100 img-fluid mobileImage" alt={altText} />
        </a>
      ) : (
        <>
          <img src={props.web_url} className="w-100 img-fluid desktopImage" alt={altText} />
          <img src={props.mobile_url} className="w-100 img-fluid mobileImage" alt={altText} />
        </>
      )}
    </div>
  );
}
